// extracted by mini-css-extract-plugin
module.exports = {"main-component":"userResearch_main-component__Hwjdv"};